// Keep the following in sync with packages/rum-slim/src/index.ts
export { datadogRum } from './boot/rum.entry';
export { DefaultPrivacyLevel } from '@datadog/browser-core';
//# sourceMappingURL=index.js.map